import { useLocalStorage } from "react-use";

export function useFeatureFlag(featureFlagKey: string) {
  const [isFeatureFlag] = useLocalStorage(featureFlagKey, false);

  return isFeatureFlag;
}
